import {createAction, props} from "@ngrx/store";
import {DatacenterV2} from "../../model/datacenter-v2";
import {Provider} from "../../model/providers";

export const GET_DATACENTERS = '[Datacenters API] Get Datacenters';
export const GET_DATACENTERS_BY_PROVIDER = '[Datacenters API] Get Datacenters by provider';
export const GET_DATACENTERS_BY_PROVIDER_SUCCESS = '[Datacenters API] Get Datacenters by provider success';
export const GET_DATACENTERS_SUCCESS = '[Datacenters API] Get Datacenters Success';
export const GET_DATACENTERS_FAILURE = '[Datacenters API] Get Datacenters Failure';
export const DATACENTER_MODIFIED = '[Datacenters API] Datacenter modified';
export const REMOVE_DATACENTER = '[Datacenters API] Remove Datacenter';
export const NUKE_STORE = '[Datacenters API] Nuke Store';
export const GET_DATACENTERS_WITH_ERRORS = '[Datacenters API] Get Datacenters with errors';
export const GET_DATACENTERS_WITH_ERRORS_SUCCESS = '[Datacenters API] Get Datacenters with errors success';
export const GET_DATACENTERS_WITH_ERRORS_FAILURE = '[Datacenters API] Get Datacenters with errors failure';

export enum SourceEnum {
  POLYGON = 'POLYGON',
  PROVIDER = 'PROVIDER'
}
export type SourceDataType = {
  source: SourceEnum,
  polygon: any;
}
export const getDatacenters = createAction(
  GET_DATACENTERS,
  props<{mapId: string, pageSize: number, lastId: string}>()
);

export const getDatacentersByProvider = createAction(
  GET_DATACENTERS_BY_PROVIDER,
  props<{ mapId: string, provider: Provider, sourceData?: SourceDataType }>()
);

export const getDatacentersByProviderSuccess = createAction(
  GET_DATACENTERS_BY_PROVIDER_SUCCESS,
  props<{ provider: Provider, datacenters: DatacenterV2[], sourceData?: SourceDataType }>()
);

export const getDatacentersSuccess = createAction(
  GET_DATACENTERS_SUCCESS,
  props<{datacenters: DatacenterV2[], lastBatch: boolean}>()
);

export const getDatacentersFailure = createAction(
  GET_DATACENTERS_FAILURE,
  props<{msg: any, }>()
);

export const datacenterModified = createAction(
  DATACENTER_MODIFIED,
  props<{datacenter: DatacenterV2}>()
);

export const removeDatacenter = createAction(
  REMOVE_DATACENTER,
  props<{datacenter: DatacenterV2}>()
);

export const nukeStore = createAction(
  NUKE_STORE
);

export const getDatacentersWithErrors = createAction(
  GET_DATACENTERS_WITH_ERRORS,
  props<{mapId: string}>()
);

export const getDatacentersWithErrorsSuccess = createAction(
  GET_DATACENTERS_WITH_ERRORS_SUCCESS,
  props<{datacenters: DatacenterV2[]}>()
);

export const getDatacentersWithErrorsFailure = createAction(
  GET_DATACENTERS_WITH_ERRORS_FAILURE,
  props<{msg: any}>()
);
